/**
 * B1 / AP-5 (P23) — „Zuletzt verwendete Ordner". Abgeleitet aus den zuletzt
 * geöffneten Dateien (guard-gefiltert serverseitig); Klick öffnet den Ordner in
 * „Meine Dateien". Trash/Archiv sind serverseitig ausgeschlossen.
 */

import { useCallback, useEffect, useState } from "react";

import { ApiError, ryfeApi } from "../api";
import { useRyfe } from "../RyfeContext";
import { navigate } from "../router";

import "./ryfe.scss";

import type { RecentFolder } from "../api";

const fmtDate = (s?: string | null) => (s ? new Date(s).toLocaleString() : "—");

export const RyfeRecentFolders = () => {
  const { workspace } = useRyfe();
  const wsId = workspace?.id;
  const [folders, setFolders] = useState<RecentFolder[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!wsId) {
      return;
    }
    try {
      const r = await ryfeApi.listRecentFolders(wsId);
      setFolders(r.folders);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "Laden fehlgeschlagen");
    }
  }, [wsId]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="ryfe-page">
      <h1 className="ryfe-page__title">Zuletzt verwendet</h1>

      {error && <div className="ryfe-notice ryfe-notice--warn">{error}</div>}

      {folders && folders.length === 0 ? (
        <p className="ryfe-muted" style={{ padding: 0 }}>
          Noch keine zuletzt verwendeten Ordner.
        </p>
      ) : (
        <div className="ryfe-table-wrap">
          <table className="ryfe-table">
            <thead>
              <tr>
                <th>Ordner</th>
                <th>Zuletzt geöffnet</th>
              </tr>
            </thead>
            <tbody>
              {(folders || []).map((f) => (
                <tr className="ryfe-row" key={f.id}>
                  <td>
                    <button
                      className="ryfe-btn--link"
                      onClick={() => navigate(`/files/${f.id}`)}
                    >
                      {f.name}
                    </button>
                  </td>
                  <td>{fmtDate(f.last_opened_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
